import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import { useState } from "react";
import { Helmet } from "react-helmet-async";
import Button from "../../Components/Button/Button";
import Input from "../../Components/Input/Input";
import TextArea from "../../Components/Input/TextArea";
import styles from "./Contact.module.scss";
import { contactSchema, bookingType } from "./contact.schema";
import { ContactService } from "../../services/contact.service";

const ContactUs = () => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({
    resolver: yupResolver(contactSchema),
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitMessage, setSubmitMessage] = useState<string | null>(null);

  const contactService = ContactService.getInstance();

  const submitResponse = async (data: bookingType) => {
    setIsSubmitting(true);
    setSubmitMessage(null);

    try {
      const response = await contactService.submitContactForm(data);
      setSubmitMessage(response.message);

      // Only reset form if submission was successful
      if (response.success) {
        reset();
      }
    } catch (error) {
      setSubmitMessage(
        "Thank you for contacting us. We will get back to you soon."
      );
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className={styles.contactUS}>
      <Helmet>
        <title>Contact Chauffeur Rides Ltd | Book Luxury Chauffeur London</title>
        <meta name="description" content="Contact Chauffeur Rides Ltd to book luxury chauffeur services in London. Airport transfers, corporate travel, private jet & cruise transfers available 24/7." />
      </Helmet>
      <h2>Contact Us</h2>
      <form
        onSubmit={handleSubmit(submitResponse)}
        className={styles.contactUS__container}
      >
        <div>
          <Input
            name="name"
            register={register}
            label={"Name"}
            errorMessage={errors.name?.message}
          />
        </div>
        <div>
          <Input
            name="email"
            register={register}
            label={"Email"}
            errorMessage={errors.email?.message}
          />
        </div>
        <div>
          <TextArea
            register={register}
            name="message"
            label={"Message"}
            errorMessage={errors.message?.message}
          />
        </div>

        {submitMessage && (
          <div
            style={{
              color: submitMessage.includes("required") ||
                     submitMessage.includes("must") ||
                     submitMessage.includes("exceed") ||
                     submitMessage.includes("valid") ||
                     submitMessage.includes("wrong")
                ? "red"
                : "green",
              marginBottom: "1rem",
            }}
          >
            {submitMessage}
          </div>
        )}

        <Button
          type="submit"
          label={isSubmitting ? "Submitting..." : "Submit"}
          disabled={isSubmitting}
        />
      </form>
    </div>
  );
};

export default ContactUs;
